import React from 'react';
import { useInView } from '../../lib/useInView';

/**
 * Soft reveal for Gen AI landing — no opacity:0 flash (avoids scroll flicker).
 */
const GenAiReveal = ({ children, className = '', delay = 0, as: Tag = 'div' }) => {
  const [ref, inView] = useInView({
    threshold: 0.05,
    rootMargin: '0px 0px 12% 0px',
  });

  return (
    <Tag
      ref={ref}
      className={`gen-ai-reveal transition-[transform] duration-500 ease-out will-change-transform ${
        inView ? 'translate-y-0' : 'translate-y-3'
      } ${className}`}
      style={{ transitionDelay: inView ? `${delay}ms` : '0ms' }}
    >
      {children}
    </Tag>
  );
};

export default GenAiReveal;
